class BrixRegionsMap {
  static init(...parameters) {
    return new BrixRegionsMap(...parameters);
  }

  constructor(block) {
    const regions = block.querySelectorAll('a.region');

    [...regions].forEach((region) => {
      region.addEventListener('mouseover', () => {
        const overlay = document.querySelector(`.overlay.-${region.dataset.region}`);
        overlay.classList.add('-visible');
      });

      region.addEventListener('mouseout', () => {
        const overlay = document.querySelector(`.overlay.-${region.dataset.region}`);
        overlay.classList.remove('-visible');
      });
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-regions-map', BrixRegionsMap.init);
}
